var _circle, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5819_33109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#009C3B"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5819_33109)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8571 3H-0.857147V21H24.8571V3Z",
    fill: "#009C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32858 12L12 18.8143L22.6714 12L12 5.18571L1.32858 12Z",
    fill: "#FFDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    fill: "#002776"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5819_33109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 10,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5819_33109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 21C-1.5 14.9643 3.39289 10.0714 9.42857 10.0714C15.4643 10.0714 20.3571 14.9643 20.3571 21H19.7143C19.7143 15.3194 15.1092 10.7143 9.42857 10.7143C3.74793 10.7143 -0.857143 15.3194 -0.857143 21H-1.5Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10975 10.2593C8.21547 10.2463 8.31287 10.331 8.32729 10.4484C8.34171 10.5659 8.2677 10.6717 8.16198 10.6846C8.05627 10.6976 7.95887 10.6129 7.94445 10.4954C7.93003 10.378 8.00404 10.2722 8.10975 10.2593ZM8.11945 10.3383C8.05737 10.3459 8.01438 10.4119 8.02345 10.4857C8.03251 10.5596 8.0902 10.6133 8.15228 10.6056C8.21437 10.598 8.25736 10.532 8.24829 10.4581C8.23922 10.3843 8.18154 10.3306 8.11945 10.3383Z",
    fill: "#009B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7317 10.2009C8.80591 10.1957 8.87027 10.2516 8.87546 10.3258C8.88065 10.4001 8.8247 10.4644 8.75049 10.4696L8.57948 10.4816L8.59059 10.6404L8.51119 10.6459L8.4874 10.218L8.7317 10.2009ZM8.73115 10.2807L8.56624 10.2922L8.57393 10.4022L8.73883 10.3906C8.76919 10.3885 8.79208 10.3622 8.78996 10.3318C8.78784 10.3015 8.7615 10.2786 8.73115 10.2807Z",
    fill: "#009B3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87458 10.6205C8.87031 10.5594 8.86092 10.4251 8.7693 10.4315L8.65326 10.4396C8.78763 10.4302 8.79702 10.5646 8.80129 10.6256",
    fill: "#009B3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24888 10.1801C9.29759 10.1792 9.34464 10.1978 9.37968 10.2316C9.41472 10.2654 9.43489 10.3118 9.43574 10.3605L9.4368 10.4217C9.43857 10.5231 9.35779 10.6068 9.25636 10.6086L9.05435 10.6121L9.04688 10.1836L9.24888 10.1801ZM9.24415 10.2598L9.12784 10.2618L9.13255 10.5311L9.24885 10.5291C9.31309 10.528 9.36425 10.475 9.36313 10.4108L9.36249 10.374C9.36137 10.3098 9.30839 10.2586 9.24415 10.2598Z",
    fill: "#009B3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59851 10.6068L9.98399 10.6202L9.98676 10.5407L9.67471 10.5298L9.67856 10.4196L9.9233 10.4282L9.92587 10.3548L9.68112 10.3462L9.68411 10.2606L9.97781 10.2708L9.98059 10.1913L9.61346 10.1785L9.59851 10.6068Z",
    fill: "#009B3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1422 10.6299L10.2154 10.6363L10.241 10.3435L10.3008 10.6438L10.3679 10.6496L10.4789 10.3643L10.4533 10.6571L10.5265 10.6635L10.5638 10.2366L10.4571 10.2272L10.3461 10.5125L10.2863 10.2123L10.1796 10.2029L10.1422 10.6299Z",
    fill: "#009B3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0302 10.7301L11.347 10.7845L11.3594 10.7121L11.115 10.6701L11.1316 10.5735L11.3308 10.6078L11.3432 10.5354L11.1441 10.5011L11.1555 10.4348L11.3923 10.4755L11.4048 10.4031L11.0955 10.3499L11.0302 10.7301Z",
    fill: "#009B3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1943 10.5378C12.2664 10.5565 12.3097 10.6299 12.291 10.702C12.2724 10.774 12.1989 10.8173 12.1269 10.7986L11.9609 10.7557L11.9211 10.9098L11.844 10.8899L11.9573 10.4765L12.1943 10.5378ZM12.1685 10.6134L12.0085 10.572L11.9809 10.6787L12.1409 10.7201C12.1704 10.7277 12.2004 10.71 12.208 10.6805C12.2157 10.651 12.198 10.621 12.1685 10.6134Z",
    fill: "#009B3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7381 10.6969C12.809 10.7193 12.8484 10.7949 12.826 10.8659C12.8037 10.9368 12.728 10.9762 12.6571 10.9538L12.4936 10.9023L12.4457 11.0541L12.3698 11.0302L12.5045 10.6233L12.7381 10.6969ZM12.7083 10.771L12.5507 10.7213L12.5175 10.8264L12.6752 10.8761C12.7042 10.8852 12.7351 10.8691 12.7443 10.8401C12.7535 10.8111 12.7373 10.7801 12.7083 10.771Z",
    fill: "#009B3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7173 11.1397C12.7357 11.0813 12.7762 10.9529 12.6886 10.9252L12.5776 10.8903C12.7061 10.9308 12.6656 11.0592 12.6472 11.1176",
    fill: "#009B3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2183 10.8639C13.3181 10.9012 13.3653 11.0213 13.3239 11.1321C13.2825 11.243 13.168 11.3026 13.0682 11.2653C12.9684 11.228 12.9212 11.1079 12.9626 10.9971C13.0041 10.8862 13.1185 10.8266 13.2183 10.8639ZM13.1904 10.9384C13.1318 10.9165 13.0632 10.9553 13.0372 11.0249C13.0111 11.0946 13.0375 11.1689 13.0961 11.1908C13.1547 11.2127 13.2233 11.1739 13.2494 11.1043C13.2754 11.0346 13.249 10.9603 13.1904 10.9384Z",
    fill: "#009B3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5819_33109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 1,
    height: 2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3958 11.3922L13.5667 10.9992L13.9205 11.153L13.7496 11.546L13.3958 11.3922ZM13.6875 11.2052L13.6582 11.2726L13.835 11.3495L13.8643 11.2821L13.6875 11.2052Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5819_33109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7436 11.0761C13.8413 11.1186 13.8822 11.241 13.835 11.3495C13.7878 11.4581 13.6704 11.5116 13.5727 11.4691C13.475 11.4267 13.4341 11.3043 13.4813 11.1957C13.5285 11.0872 13.6459 11.0336 13.7436 11.0761ZM13.7119 11.1491C13.6545 11.1242 13.5839 11.1592 13.5543 11.2275C13.5246 11.2957 13.5471 11.3712 13.6044 11.3961C13.6618 11.4211 13.7324 11.386 13.762 11.3178C13.7917 11.2496 13.7692 11.174 13.7119 11.1491Z",
    fill: "#009B3A"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.835 11.3495L13.6862 11.2848L13.6618 11.341L13.8106 11.4056L13.835 11.3495Z",
    fill: "#009B3A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.835 11.3495L13.7789 11.3251L13.6934 11.5216L13.7496 11.546L13.835 11.3495Z",
    fill: "#009B3A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3091 11.3415C14.3757 11.3747 14.4028 11.4556 14.3696 11.5221C14.3364 11.5887 14.2555 11.6158 14.1889 11.5826L14.0355 11.5061L13.9645 11.6485L13.8932 11.613L14.09 11.2322L14.3091 11.3415ZM14.2681 11.41L14.1202 11.3362L14.071 11.4349L14.219 11.5086C14.2462 11.5222 14.2793 11.5111 14.2929 11.4839C14.3064 11.4567 14.2954 11.4236 14.2681 11.41Z",
    fill: "#009B3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2193 11.7756C14.2466 11.7208 14.3067 11.6002 14.2245 11.5593L14.1204 11.5074C14.2409 11.5675 14.1808 11.688 14.1535 11.7428",
    fill: "#009B3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3784 11.8596L14.7141 12.0495L14.7533 11.9802L14.4815 11.8265L14.5358 11.7305L14.7489 11.8511L14.7851 11.7872L14.572 11.6666L14.6142 11.592L14.8699 11.7367L14.9091 11.6674L14.5894 11.4865L14.3784 11.8596Z",
    fill: "#009B3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0037 12.0694C14.9806 12.1055 15.004 12.1458 15.0556 12.1787C15.1073 12.2116 15.1424 12.2104 15.1573 12.1872C15.2041 12.1136 14.9331 12.0063 15.0167 11.878C15.0887 11.7678 15.2119 11.8536 15.2584 11.8832C15.3049 11.9128 15.3795 11.9894 15.3214 12.0776L15.2427 12.0274C15.2674 11.9887 15.2403 11.9515 15.199 11.9252C15.1589 11.8997 15.1264 11.888 15.1026 11.9255C15.0626 11.9853 15.3282 12.0983 15.2468 12.2261C15.1868 12.3203 15.0823 12.2792 15.0126 12.2348C14.9532 12.1969 14.8645 12.1077 14.9223 12.0175L15.0037 12.0694Z",
    fill: "#009B3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4634 12.3734C15.4385 12.4083 15.4597 12.4497 15.5096 12.4853C15.5594 12.5208 15.5946 12.5215 15.6107 12.4991C15.6613 12.428 15.3963 12.3067 15.4864 12.183C15.5641 12.0767 15.6827 12.1688 15.7275 12.2008C15.7724 12.2328 15.8429 12.3132 15.7803 12.3982L15.7043 12.344C15.731 12.3066 15.7059 12.268 15.666 12.2396C15.6274 12.2121 15.5955 12.1987 15.5697 12.2349C15.5267 12.2925 15.786 12.4192 15.698 12.5426C15.6332 12.6336 15.531 12.587 15.4637 12.539C15.4064 12.4981 15.3225 12.4044 15.3849 12.3174L15.4634 12.3734Z",
    fill: "#009B3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1651 12.5311C16.2484 12.5974 16.2563 12.7262 16.1826 12.8188C16.1089 12.9114 15.9816 12.9328 15.8983 12.8665C15.8149 12.8002 15.8071 12.6713 15.8807 12.5787C15.9544 12.4861 16.0817 12.4648 16.1651 12.5311ZM16.1155 12.5934C16.0666 12.5544 15.9893 12.57 15.943 12.6283C15.8967 12.6865 15.8989 12.7652 15.9478 12.8042C15.9968 12.8431 16.074 12.8275 16.1203 12.7693C16.1666 12.7111 16.1645 12.6323 16.1155 12.5934Z",
    fill: "#009B3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32654 10.999L8.26694 11.1824L8.35865 11.2122",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32654 10.999L8.38613 11.1824L8.29443 11.2122",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50995 11.1322L8.31709 11.1322L8.31709 11.2287",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50992 11.1322L8.35389 11.2456L8.29721 11.1676",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1431 11.1322L8.29912 11.2456L8.3558 11.1676",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1431 11.1322L8.33595 11.1322L8.33595 11.2287",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43988 11.3479L8.38028 11.1644L8.28858 11.1942",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43988 11.3479L8.28386 11.2345L8.34054 11.1565",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21317 11.3479L8.36919 11.2345L8.31251 11.1565",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21317 11.3479L8.27276 11.1644L8.36447 11.1942",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72449 12.8908L8.66489 13.0742L8.7566 13.104",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72449 12.8908L8.78408 13.0742L8.69237 13.104",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90793 13.0241L8.71507 13.0241L8.71507 13.1205",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9079 13.0241L8.75187 13.1374L8.69519 13.0594",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54108 13.0241L8.6971 13.1374L8.75378 13.0594",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54105 13.0241L8.7339 13.0241L8.7339 13.1205",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83783 13.2397L8.77823 13.0563L8.68652 13.0861",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83783 13.2397L8.6818 13.1263L8.73848 13.0483",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61111 13.2397L8.76714 13.1264L8.71046 13.0483",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61111 13.2397L8.67071 13.0563L8.76242 13.0861",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17346 13.327L8.1238 13.4799L8.20022 13.5047",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17349 13.327L8.22316 13.4799L8.14673 13.5047",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32632 13.4381L8.16561 13.4381L8.16561 13.5185",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32632 13.4381L8.1963 13.5326L8.14907 13.4676",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02063 13.4381L8.15065 13.5326L8.19788 13.4676",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02063 13.4381L8.18134 13.4381L8.18134 13.5185",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26794 13.6178L8.21828 13.4649L8.14186 13.4898",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26794 13.6178L8.13792 13.5233L8.18516 13.4583",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07901 13.6178L8.20903 13.5233L8.1618 13.4583",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07901 13.6178L8.12867 13.4649L8.2051 13.4898",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16528 12.7163L9.1369 12.8037L9.18058 12.8179",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16528 12.7163L9.19366 12.8037L9.14999 12.8179",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25262 12.7798L9.16079 12.7798L9.16079 12.8257",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25266 12.7798L9.17836 12.8338L9.15137 12.7966",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07794 12.7798L9.15224 12.8338L9.17923 12.7966",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07794 12.7798L9.16978 12.7798L9.16978 12.8257",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21927 12.8825L9.19089 12.7951L9.14722 12.8093",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21927 12.8825L9.14497 12.8285L9.17196 12.7913",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1113 12.8825L9.1856 12.8285L9.15861 12.7913",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1113 12.8825L9.13968 12.7951L9.18335 12.8093",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66119 13.3699L9.61153 13.5228L9.68795 13.5476",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66122 13.3699L9.71089 13.5228L9.63446 13.5476",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81406 13.4809L9.65334 13.4809L9.65334 13.5613",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81406 13.4809L9.68404 13.5754L9.6368 13.5104",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50836 13.4809L9.63838 13.5754L9.68562 13.5104",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50836 13.4809L9.66908 13.4809L9.66908 13.5613",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75568 13.6606L9.70601 13.5078L9.62959 13.5326",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75568 13.6606L9.62566 13.5662L9.67289 13.5012",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56674 13.6606L9.69676 13.5661L9.64953 13.5011",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56674 13.6606L9.61641 13.5078L9.69283 13.5326",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52652 13.8489L9.48679 13.9712L9.54793 13.9911",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52652 13.8489L9.56625 13.9712L9.50511 13.9911",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6488 13.9378L9.52023 13.9378L9.52023 14.0021",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6488 13.9378L9.54479 14.0134L9.507 13.9614",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40424 13.9378L9.50825 14.0134L9.54604 13.9614",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40424 13.9378L9.53281 13.9378L9.53281 14.0021",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60208 14.0816L9.56235 13.9593L9.50121 13.9791",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60208 14.0816L9.49806 14.006L9.53585 13.954",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45093 14.0816L9.55494 14.006L9.51716 13.954",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45093 14.0816L9.49066 13.9593L9.5518 13.9792",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3959 10.4112L13.3363 10.5946L13.428 10.6244",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3959 10.4112L13.4555 10.5946L13.3638 10.6244",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5793 10.5445L13.3865 10.5445L13.3865 10.6409",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5793 10.5445L13.4233 10.6579L13.3666 10.5799",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2125 10.5445L13.3685 10.6579L13.4252 10.5799",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2125 10.5445L13.4054 10.5445L13.4054 10.6409",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5093 10.7601L13.4497 10.5767L13.358 10.6065",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5093 10.7601L13.3533 10.6468L13.4099 10.5687",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2826 10.7601L13.4386 10.6467L13.3819 10.5687",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2826 10.7601L13.3422 10.5767L13.4339 10.6065",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1531 13.3867L15.0935 13.5701L15.1852 13.5999",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1531 13.3867L15.2127 13.5701L15.121 13.5999",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3365 13.52L15.1436 13.52L15.1436 13.6164",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3365 13.52L15.1805 13.6333L15.1238 13.5553",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9697 13.52L15.1257 13.6333L15.1824 13.5553",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9696 13.52L15.1625 13.52L15.1625 13.6164",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2664 13.7356L15.2069 13.5522L15.1151 13.582",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2664 13.7356L15.1104 13.6223L15.1671 13.5442",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0397 13.7356L15.1958 13.6223L15.1391 13.5442",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0397 13.7356L15.0993 13.5522L15.191 13.582",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 13.4939L15.7378 13.6162L15.799 13.6361",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 13.4939L15.8173 13.6162L15.7561 13.6361",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8998 13.5827L15.7713 13.5827L15.7713 13.647",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8998 13.5827L15.7958 13.6583L15.758 13.6063",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6553 13.5827L15.7593 13.6583L15.7971 13.6063",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6553 13.5827L15.7838 13.5827L15.7838 13.647",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8531 13.7265L15.8134 13.6042L15.7522 13.6241",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8531 13.7265L15.7491 13.6509L15.7869 13.5989",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15.702 13.7265L15.806 13.6509L15.7682 13.5989",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M15.702 13.7265L15.7417 13.6042L15.8028 13.6241",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3367 13.8168L15.2871 13.9697L15.3635 13.9945",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3368 13.8168L15.3864 13.9697L15.31 13.9945",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4896 13.9279L15.3289 13.9279L15.3289 14.0082",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4896 13.9279L15.3596 14.0224L15.3123 13.9573",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1839 13.9279L15.3139 14.0224L15.3612 13.9573",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1839 13.9279L15.3446 13.9279L15.3446 14.0082",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4312 14.1076L15.3816 13.9547L15.3051 13.9795",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4312 14.1076L15.3012 14.0131L15.3484 13.9481",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2423 14.1075L15.3723 14.0131L15.3251 13.9481",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2423 14.1075L15.2919 13.9547L15.3684 13.9795",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2531 14.7597L14.2034 14.9125L14.2798 14.9374",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2531 14.7597L14.3027 14.9125L14.2263 14.9374",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4059 14.8708L14.2452 14.8708L14.2452 14.9511",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4059 14.8708L14.2759 14.9652L14.2287 14.9002",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1002 14.8707L14.2302 14.9652L14.2775 14.9002",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1002 14.8708L14.2609 14.8708L14.2609 14.9511",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3475 15.0504L14.2979 14.8976L14.2214 14.9224",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3475 15.0504L14.2175 14.956L14.2647 14.891",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 15.0504L14.2886 14.956L14.2414 14.891",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 15.0504L14.2083 14.8976L14.2847 14.9224",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2469 15.2449L14.2072 15.3672L14.2683 15.3871",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2469 15.2449L14.2866 15.3672L14.2255 15.3871",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3692 15.3337L14.2407 15.3337L14.2407 15.398",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3692 15.3337L14.2652 15.4093L14.2274 15.3573",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1247 15.3338L14.2287 15.4093L14.2665 15.3573",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1247 15.3338L14.2532 15.3338L14.2532 15.3981",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3225 15.4775L14.2828 15.3552L14.2216 15.3751",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3225 15.4775L14.2185 15.4019L14.2563 15.3499",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1714 15.4775L14.2754 15.4019L14.2376 15.3499",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1714 15.4775L14.2111 15.3552L14.2722 15.3751",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.4367L14.6603 14.559L14.7214 14.5789",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 14.4367L14.7397 14.559L14.6786 14.5789",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8223 14.5256L14.6937 14.5256L14.6937 14.5898",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8223 14.5256L14.7183 14.6012L14.6805 14.5492",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5777 14.5256L14.6817 14.6011L14.7195 14.5491",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5777 14.5256L14.7063 14.5256L14.7063 14.5898",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7756 14.6693L14.7358 14.547L14.6747 14.5669",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7756 14.6693L14.6716 14.5938L14.7093 14.5417",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6244 14.6693L14.7284 14.5937L14.6907 14.5417",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6244 14.6693L14.6642 14.547L14.7253 14.5669",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0612 14.178L15.0116 14.3309L15.088 14.3557",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0612 14.178L15.1109 14.3309L15.0345 14.3557",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2141 14.2891L15.0534 14.2891L15.0534 14.3694",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2141 14.2891L15.0841 14.3836L15.0368 14.3185",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9084 14.2891L15.0384 14.3836L15.0856 14.3185",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9084 14.2891L15.0691 14.2891L15.0691 14.3695",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1557 14.4688L15.106 14.3159L15.0296 14.3407",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1557 14.4688L15.0257 14.3743L15.0729 14.3093",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9668 14.4688L15.0968 14.3743L15.0496 14.3093",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9668 14.4688L15.0165 14.3159L15.0929 14.3408",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2347 14.3511L14.1949 14.4734L14.2561 14.4932",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2347 14.3511L14.2744 14.4734L14.2133 14.4932",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M14.357 14.4399L14.2284 14.4399L14.2284 14.5042",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M14.357 14.4399L14.253 14.5155L14.2152 14.4634",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1124 14.4399L14.2164 14.5155L14.2542 14.4634",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1124 14.4399L14.241 14.4399L14.241 14.5042",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3102 14.5836L14.2705 14.4614L14.2094 14.4812",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3102 14.5836L14.2062 14.508L14.244 14.456",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1591 14.5836L14.2631 14.5081L14.2253 14.4561",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1591 14.5836L14.1988 14.4614L14.26 14.4812",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 12.023L10.236 12.1758L10.3125 12.2006",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 12.023L10.3354 12.1758L10.259 12.2006",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4386 12.134L10.2779 12.134L10.2779 12.2144",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4386 12.134L10.3085 12.2285L10.2613 12.1635",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1329 12.134L10.2629 12.2285L10.3101 12.1635",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1329 12.134L10.2936 12.134L10.2936 12.2144",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3802 12.3137L10.3305 12.1609L10.2541 12.1857",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3802 12.3137L10.2502 12.2192L10.2974 12.1542",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 12.3137L10.3213 12.2193L10.274 12.1542",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1913 12.3137L10.2409 12.1609L10.3173 12.1857",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2245 11.6449L13.1847 11.7672L13.2459 11.7871",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2245 11.6449L13.2642 11.7672L13.203 11.7871",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3468 11.7338L13.2182 11.7338L13.2182 11.798",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3468 11.7338L13.2428 11.8093L13.205 11.7573",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1022 11.7337L13.2062 11.8093L13.244 11.7573",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1022 11.7338L13.2308 11.7338L13.2308 11.798",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.8775L13.2603 11.7552L13.1992 11.7751",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.8775L13.196 11.8019L13.2338 11.7499",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1489 11.8775L13.2529 11.8019L13.2151 11.7499",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1489 11.8775L13.1886 11.7552L13.2498 11.7751",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8276L11.9404 14.011L12.0321 14.0408",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8276L12.0596 14.011L11.9679 14.0408",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1834 13.9608L11.9906 13.9608L11.9906 14.0572",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1834 13.9608L12.0274 14.0742L11.9707 13.9962",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8166 13.9608L11.9726 14.0742L12.0293 13.9962",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8166 13.9608L12.0094 13.9608L12.0094 14.0572",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1134 14.1764L12.0538 13.993L11.9621 14.0228",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1134 14.1764L11.9573 14.063L12.014 13.985",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 14.1764L12.0427 14.0631L11.986 13.9851",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8867 14.1764L11.9463 13.993L12.038 14.0228",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5204 12.9658L12.4707 13.1186L12.5471 13.1435",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5204 12.9658L12.5701 13.1186L12.4937 13.1435",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6732 13.0769L12.5125 13.0769L12.5125 13.1572",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6732 13.0769L12.5432 13.1713L12.496 13.1063",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3676 13.0769L12.4976 13.1713L12.5448 13.1063",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3676 13.0769L12.5283 13.0769L12.5283 13.1572",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6149 13.2565L12.5652 13.1037L12.4888 13.1285",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6149 13.2565L12.4848 13.1621L12.5321 13.0971",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4259 13.2565L12.556 13.1621L12.5087 13.0971",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M12.426 13.2565L12.4756 13.1037L12.5521 13.1285",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5617L11.9503 12.7146L12.0268 12.7394",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5617L12.0497 12.7146L11.9733 12.7394",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1529 12.6728L11.9921 12.6728L11.9921 12.7531",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1529 12.6728L12.0228 12.7672L11.9756 12.7022",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8472 12.6728L11.9772 12.7672L12.0244 12.7022",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8472 12.6728L12.0079 12.6728L12.0079 12.7531",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0945 12.8524L12.0448 12.6996L11.9684 12.7244",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0945 12.8524L11.9645 12.758L12.0117 12.693",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9055 12.8525L12.0356 12.758L11.9883 12.693",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9055 12.8525L11.9552 12.6996L12.0316 12.7244",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 12.9979L11.5072 13.1202L11.5683 13.1401",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5469 12.9979L11.5866 13.1202L11.5255 13.1401",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6692 13.0868L11.5406 13.0868L11.5406 13.1511",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6692 13.0868L11.5652 13.1624L11.5274 13.1104",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4247 13.0868L11.5287 13.1624L11.5665 13.1104",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4247 13.0868L11.5532 13.0868L11.5532 13.1511",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6225 13.2305L11.5828 13.1083L11.5216 13.1281",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6225 13.2305L11.5185 13.155L11.5563 13.103",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4713 13.2305L11.5754 13.155L11.5376 13.1029",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4713 13.2305L11.5111 13.1083L11.5722 13.1281",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7735 13.3469L11.7451 13.4343L11.7888 13.4484",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7735 13.3469L11.8018 13.4342L11.7582 13.4484",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8608 13.4104L11.769 13.4104L11.769 13.4563",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8608 13.4104L11.7865 13.4644L11.7595 13.4272",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6861 13.4104L11.7604 13.4644L11.7874 13.4272",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6862 13.4104L11.778 13.4104L11.778 13.4563",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8275 13.5131L11.7991 13.4257L11.7554 13.4399",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8275 13.5131L11.7532 13.4591L11.7801 13.4219",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 13.5131L11.7938 13.4591L11.7668 13.4219",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 13.5131L11.7479 13.4257L11.7915 13.4399",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3469 14.8699L13.2973 15.0228L13.3737 15.0476",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M13.347 14.8699L13.3966 15.0228L13.3202 15.0476",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 14.9809L13.3391 14.9809L13.3391 15.0613",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 14.9809L13.3698 15.0754L13.3225 15.0104",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1941 14.9809L13.3241 15.0754L13.3713 15.0104",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1941 14.9809L13.3548 14.9809L13.3548 15.0613",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 15.1606L13.3917 15.0078L13.3153 15.0326",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 15.1606L13.3114 15.0662L13.3586 15.0012",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2525 15.1606L13.3825 15.0662L13.3353 15.0012",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2525 15.1607L13.3021 15.0078L13.3786 15.0326",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7326 14.504L13.6929 14.6263L13.754 14.6462",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7326 14.504L13.7724 14.6263L13.7112 14.6462",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8549 14.5929L13.7264 14.5929L13.7264 14.6572",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8549 14.5929L13.7509 14.6685L13.7131 14.6165",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6104 14.5929L13.7144 14.6685L13.7522 14.6165",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6104 14.5929L13.739 14.5929L13.739 14.6572",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8082 14.7367L13.7685 14.6144L13.7074 14.6343",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8082 14.7367L13.7042 14.6611L13.742 14.6091",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 14.7367L13.7611 14.6611L13.7233 14.6091",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 14.7367L13.6968 14.6144L13.7579 14.6343",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9918 14.3939L12.9521 14.5162L13.0132 14.536",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9918 14.3939L13.0316 14.5162L12.9704 14.536",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1141 14.4827L12.9855 14.4827L12.9855 14.547",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1141 14.4827L13.0101 14.5583L12.9723 14.5063",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8695 14.4827L12.9736 14.5583L13.0113 14.5063",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8695 14.4827L12.9981 14.4827L12.9981 14.547",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0674 14.6265L13.0277 14.5042L12.9665 14.5241",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0674 14.6265L12.9634 14.5509L13.0012 14.4989",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9162 14.6265L13.0202 14.5509L12.9825 14.4989",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9162 14.6265L12.956 14.5042L13.0171 14.5241",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1939 14.1949L10.1343 14.3783L10.226 14.4081",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1939 14.1949L10.2535 14.3783L10.1618 14.4081",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3773 14.3282L10.1844 14.3282L10.1844 14.4246",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3773 14.3282L10.2212 14.4415L10.1646 14.3635",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0105 14.3282L10.1665 14.4415L10.2232 14.3635",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0105 14.3282L10.2033 14.3282L10.2033 14.4246",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3073 14.5438L10.2477 14.3604L10.1559 14.3902",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3073 14.5438L10.1512 14.4304L10.2079 14.3524",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0805 14.5438L10.2365 14.4304L10.1799 14.3524",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0805 14.5438L10.1401 14.3604L10.2318 14.3902",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.4561L11.98 15.5173L12.0106 15.5272",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 15.4561L12.0202 15.5173L11.9896 15.5272",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0611 15.5004L11.9968 15.5004L11.9968 15.5326",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0612 15.5008L12.0092 15.5386L11.9903 15.5126",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9388 15.5007L11.9908 15.5384L12.0097 15.5124",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M11.939 15.5002L12.0033 15.5002L12.0033 15.5324",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0379 15.5723L12.018 15.5112L11.9875 15.5211",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0376 15.5726L11.9856 15.5348L12.0045 15.5088",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9623 15.5725L12.0143 15.5347L11.9955 15.5087",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M11.962 15.5722L11.9818 15.5111L12.0124 15.521",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/Brazil.4bf36b43bf8d43ea55913829b4289c72.svg";
export { ForwardRef as ReactComponent };